import React from "react";
import { DialogActions, DialogBody, DialogBox, DialogOverlay, DialogTitle } from "../styles";
import { LABELS } from "../labels";
import type { TextRegistryScope } from "../types";

interface Props {
	open: boolean;
	scope: TextRegistryScope;
	publishing: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const SCOPE_LABEL: Record<TextRegistryScope, string> = {
	admin: LABELS.scopeAdmin,
	homepage: LABELS.scopeHomepage,
	stations: LABELS.scopeStations,
};

export default function PublishConfirmDialog({ open, scope, publishing, onConfirm, onCancel }: Props) {
	if (!open) return null;

	return (
		<DialogOverlay onClick={onCancel}>
			<DialogBox onClick={(e) => e.stopPropagation()}>
				<DialogTitle>{LABELS.publishConfirmTitle}</DialogTitle>
				<DialogBody>{LABELS.publishConfirmBody(SCOPE_LABEL[scope])}</DialogBody>
				<DialogActions>
					<button
						onClick={onCancel}
						style={{
							padding: "8px 16px",
							border: "1px solid #e2e8f0",
							borderRadius: 8,
							background: "#fff",
							color: "#374151",
							fontSize: "0.875rem",
							cursor: "pointer",
						}}>
						{LABELS.publishConfirmCancel}
					</button>
					<button
						onClick={onConfirm}
						disabled={publishing}
						style={{
							padding: "8px 20px",
							border: "none",
							borderRadius: 8,
							background: publishing ? "#94a3b8" : "#2563eb",
							color: "#fff",
							fontSize: "0.875rem",
							fontWeight: 600,
							cursor: publishing ? "not-allowed" : "pointer",
						}}>
						{publishing ? "Publishing…" : LABELS.publishConfirmOk}
					</button>
				</DialogActions>
			</DialogBox>
		</DialogOverlay>
	);
}
